import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';

import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';

import useReportMonitorReady from '../../../../hooks/useReportMonitorReady';
import { listenInTab_AC } from '../../../../store/actions/executor.actions';
import { HermesysColors } from '../../Colors';
import ConnectionDisplay from './ConnectionDisplay';

const Container = styled.div`
  width: 1100px;
  height: 300px;
  display: grid;
  grid-template-columns: 50% 50%;
  grid-column-gap: 50px;
`;
const LeftContainer = styled.div`
  display: grid;
  grid-template-columns: 10% 90%;
  align-items: center;
`;
const RightContainer = styled.div`
  display: grid;
  grid-template-columns: 24% 76%;
  align-items: center;
`;

const ConsoleContainer = styled.div`
  width: 500px;
  height: 130px;
  border: ridge 4px rgba(109, 109, 109, 1);
  background: ${HermesysColors.Blue};
  color: white;
  font-weight: bold;
`;

const buttonSize = 40;

const MovementButtonContainer = styled.div`
  display: grid;
  grid-template-columns: ${buttonSize}px ${buttonSize}px ${buttonSize}px;
  grid-template-rows: ${buttonSize}px ${buttonSize}px ${buttonSize}px;
`;

const NumberPadContainer = styled.div`
  display: grid;
  grid-template-columns: ${buttonSize}px ${buttonSize}px ${buttonSize}px ${buttonSize}px;
  grid-template-rows: ${buttonSize}px ${buttonSize}px ${buttonSize}px;
`;

const NumberButton = styled.div`
  // border: solid 1px black;
  border-radius: 20%;
  padding: 5px;
  border-radius: 50%;
`;

const ControlButton = styled.div`
  width: ${buttonSize}px;
  height: ${buttonSize}px;
  display: grid;
  align-items: center;
  justify-content: center;
`;

const BorderedContainer = styled(ControlButton as any)`
  border: solid 1px black;
`;

const WideContainer = styled(BorderedContainer as any)`
  grid-column: span 2;
  width: 100%;
`;

const Numbers = [1, 2, 3, 4, 5, 6, 7, 8, 9, 0];

const AVA20: React.FunctionComponent<any> = (props) => {
  const dispatch = useDispatch();
  const reportMonitorReady = useReportMonitorReady();
  useEffect(() => {
    reportMonitorReady('ava20');
    dispatch(listenInTab_AC());
  }, []);
  return (
    <Container>
      <LeftContainer>
        <div></div>
        <ConsoleContainer>
          <ConnectionDisplay />
        </ConsoleContainer>
      </LeftContainer>
      <RightContainer>
        <MovementButtonContainer>
          <ControlButton />
          <BorderedContainer>
            <ArrowUpwardIcon />
          </BorderedContainer>
          <ControlButton />
          <BorderedContainer>
            <ArrowBackIcon />
          </BorderedContainer>
          <BorderedContainer>
            <NumberButton>M</NumberButton>
          </BorderedContainer>
          <BorderedContainer>
            <ArrowForwardIcon />
          </BorderedContainer>
          <ControlButton />
          <BorderedContainer>
            <ArrowDownwardIcon />
          </BorderedContainer>
          <ControlButton />
        </MovementButtonContainer>
        <NumberPadContainer>
          {Numbers.map((num) => {
            return (
              <BorderedContainer key={num}>
                <NumberButton>{num}</NumberButton>
              </BorderedContainer>
            );
          })}
          <WideContainer>
            <NumberButton>ENTER</NumberButton>
          </WideContainer>
        </NumberPadContainer>
      </RightContainer>
    </Container>
  );
};

export default AVA20;
